var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfoldLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.803 0C5.733 0 0 5.82 0 13s5.732 13 12.803 13h.985a.97.97 0 00.5-.138l6.394-3.71 6.405 3.716a.974.974 0 00.489.132h.985c7.07 0 12.803-5.82 12.803-13S35.632 0 28.56 0h-.985a.97.97 0 00-.504.14l-6.39 3.708L14.277.132a.973.973 0 00-.49-.132h-.984zM1.97 13c0-6.075 4.85-11 10.833-11h.723l12.065 7-12.292 7.132c-.307.178-.496.51-.496.868v7C6.82 24 1.97 19.075 1.97 13zm20.697-8l3.924 2.277V2.723L22.667 5zm5.894-3v7c0 .359-.19.69-.497.868L15.773 17l12.064 7h.724c5.983 0 10.833-4.925 10.833-11S34.544 2 28.56 2zm-9.864 19l-3.924 2.277v-4.554L18.697 21z",
    fill: "#1B1B1B"
  })));
}
export default SvgUnfoldLogo;